import { GET_FEATURES_SUCCESS } from '../actions/api/features';

export default function features(state = {}, action) {
  switch (action.type) {
    case GET_FEATURES_SUCCESS:
      return {
        ...state,
        ...action.response
      };
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./js/reducers/features.js